"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Utils = _interopRequireDefault(require("../../util/Utils.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @class ColumnLayout
 * @desc Renders vertical columns of content with equal percentage widths separated by a margin.
 *   The "content-nopad" css class may be passed in to render the columns without margin/padding
 *   between the columns.
 *
 * @example
 *    <Layout.Row id="columns-3">
 *        <Layout.Column>
 *            column content
 *        </Layout.Column>
 *        <Layout.Column>
 *            column content
 *        </Layout.Column>
 *        <Layout.Column>
 *            column content
 *        </Layout.Column>
 *    </Layout.Row>
 */

/**
* @class Row
* @memberof ColumnLayout
* @desc The child tag/object used to pass in a row of content.
*
* @param {string} [data-id="row"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
* @param {boolean} [divided]
*     When true, put dividers in gaps between columns
* @param {boolean} [noMargin]
*     When true, don't add margin between columns
* @param {boolean} [autoWidth]
*     When true, columns don't take up whole width
*/
var Row = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row() {
    (0, _classCallCheck2.default)(this, Row);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Row, [{
    key: "render",
    value: function render() {
      var className = (0, _classnames.default)("content-columns", this.props.className, "columns-" + (_react.default.Children.count(this.props.children) || 1), {
        "content-columns--divided": this.props.divided,
        "columns-margin-none": this.props.noMargin,
        "columns-width-auto": this.props.autoWidth
      }); // Note: the columns-[number] class seems to be unecessary now that the component
      // uses flexbox. Let's remove this in V4.

      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: (0, _classnames.default)(className)
      }, this.props.children);
    }
  }]);
  return Row;
}(_react.default.Component);
/**
 * @class Column
 * @memberof ColumnLayout
 * @desc The child tag/object used to pass in a column of content.
 *
 * @param {string} [data-id="column-layout"]
 *     To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 */


(0, _defineProperty2.default)(Row, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  divided: _propTypes.default.bool
});
(0, _defineProperty2.default)(Row, "defaultProps", {
  "data-id": "row"
});

var Column = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(Column, _React$Component2);

  var _super2 = _createSuper(Column);

  function Column() {
    (0, _classCallCheck2.default)(this, Column);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(Column, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: (0, _classnames.default)("content-column", this.props.className, {
          // Mocking the userAgent in Jest is involved and has an effect
          // on all subsequent tests, so skipping in coverage.

          /* istanbul ignore next  */
          "content-column--ie11": _Utils.default.isIE11()
        })
      }, this.props.children);
    }
  }]);
  return Column;
}(_react.default.Component);

(0, _defineProperty2.default)(Column, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(Column, "defaultProps", {
  "data-id": "column-layout"
});
exports.Column = Column;
exports.Row = Row;